import * as React from 'react';

import { UploadIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

export type UploadImageProps = React.HTMLAttributes<HTMLLabelElement> & {
  onUpload: React.ChangeEventHandler<HTMLInputElement>;
  hideIcon: boolean;
};

const UploadImage = React.forwardRef<HTMLLabelElement, UploadImageProps>(
  ({ className, onUpload, hideIcon, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'flex h-full w-full cursor-pointer items-center justify-center hover:bg-primary-lighter/30',
          className
        )}
        {...props}
      >
        {!hideIcon ? <UploadIcon size={36} className="text-primary-light" /> : null}
        <input type="file" accept="image/*" className="hidden" onChange={onUpload} />
      </label>
    );
  }
);

UploadImage.displayName = 'UploadImage';

export { UploadImage };
